import * as React from 'react';

import { Chip, ChipGroup, VisuallyHidden } from '@coursera/cds-core';

import {
  filterGradingStatusValues,
  useSearchContext,
} from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/SearchContext';

import _t from 'i18n!nls/grading';

const FiltersSummary = () => {
  const { filters, setFilters } = useSearchContext();

  if (filters.gradingStatus === 'all') {
    return null;
  }

  const resetGradingStatus = () => setFilters({ ...filters, gradingStatus: 'all' });

  return (
    <React.Fragment>
      <VisuallyHidden id="filter-chip-group-label">{_t('Filtered by')}</VisuallyHidden>
      <ChipGroup aria-labelledby="filter-chip-group-label" variant="delete">
        <Chip title={_t(`Clear filter`)} onClick={resetGradingStatus}>
          {filterGradingStatusValues[filters.gradingStatus]}
        </Chip>
      </ChipGroup>
    </React.Fragment>
  );
};

export default FiltersSummary;
